import { i18n } from "@/i18n";
import { datadogRum } from "@datadog/browser-rum";
import VCalendar from "v-calendar";
import vClickOutside from "v-click-outside";
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import VueIntercom from "vue-intercom";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import App from "./App.vue";
import "./extensions";
import "./globalComponentRegistration";
import router from "./router";
import { Mixpanel } from "./service/analytics/mixpanel";
import store from "./store";
Vue.use(VueIntercom, { appId: process.env.VUE_APP_PeakIntercom });

Vue.use(vClickOutside);

Vue.component("multiselect", Multiselect);

Vue.use(VueClipboard);

Vue.use(VCalendar, {
  componentPrefix: "v",
  backgroundColor: "#282C34",
  border: "1px solid #dadada",
});

Vue.use(Croppa);

router.beforeEach((to, from, next) => {
  next();
});

router.onError((error) => {
  const regex = new RegExp(/Loading .* failed\./i);
  if (regex.test(error.message)) {
    window.location.href = `${process.env.VUE_APP_PeakAccount}update.html?v=${new Date().getTime()}`;
  }
});

Vue.config.productionTip = false;

if (process.env.VUE_APP_TYPE_ENV != 0) {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DatadogApplicationID,
    clientToken: process.env.VUE_APP_DatadogClientToken,
    site: "datadoghq.com",
    service: process.env.VUE_APP_DatadogService,
    env: process.env.VUE_APP_DatadogEnv,
    sampleRate: Number(process.env.VUE_APP_DatadogSampleRate),
    premiumSampleRate: Number(process.env.VUE_APP_DatadogPremiumSampleRate),
    tracingSampleRate: Number(process.env.VUE_APP_DatadogTracingSampleRate),
    trackInteractions: true,
    defaultPrivacyLevel: process.env.VUE_APP_DatadogSessionReplayPrivacy,
    allowedTracingOrigins: [
      process.env.VUE_APP_PeakExportService,
      process.env.VUE_APP_PeakRealTimeService,
      process.env.VUE_APP_PeakPayrollService,
      process.env.VUE_APP_PeakAuthenService,
    ],
  });
  datadogRum.startSessionReplayRecording();
}

Mixpanel.start();

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
